<template>
	<div class="score-group" :class="{ badge }">
		<span class="score-heading" v-once>Total Score</span>
		<span class="score" v-once>{{ score }}</span>
		<img class="score-icon" src="@assets/img/score-icon.svg" />
		<img class="score-rays" src="@assets/img/score-rays.png" />
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'score-group',
	props: {
		badge: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapState({
			ui: state => state.config.info.post_game,
			score: state => state.score.score,
		}),
	},
};
</script>

<style lang="scss" scoped>
	$inner-medallion-percent: 0.75;
	$medallion-size: 400px;
	$sm-medallion-size: 300px;
	$badge-size: 100px;

	.score-group {
		display: flex;
		width: $medallion-size;
		height: $medallion-size;
		font-size: $medallion-size;
		text-align: center;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		position: relative;
		margin: 0 auto;

		@include mobile {
			width: $sm-medallion-size;
			height: $sm-medallion-size;
			font-size: $sm-medallion-size;
		}

		.score-heading,
		.score {
			position: relative;
			z-index: 10;
		}

		.score-heading {
			display: block;
			color: $brand-color-primary-dark;
			text-transform: uppercase;
			font-size: 6.5%;
			font-weight: 700;
			line-height: 1;
			margin: -1em 0 0;
		}

		.score {
			display: block;
			color: $brand-color-primary-dark;
			font-size: 22.5%;
			font-weight: 700;
			line-height: 1;
			margin: -.1em 0 0;
		}

		.score-icon {
			width: percentage($inner-medallion-percent);
			height: percentage($inner-medallion-percent);
			margin: auto;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 1;
		}

		.score-rays {
			display: block;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			animation: spin 10s linear infinite;
			z-index: 0;
		}

		&.badge {
			width: $badge-size;
			height: $badge-size;
			font-size: $badge-size;

			&::after {
				content: "";
				display: block;

				width: ($badge-size * $inner-medallion-percent) * 1.05;
				height: ($badge-size * $inner-medallion-percent) * 1.05;

				background-color: $brand-color-primary-dark;
				border-radius: 50%;

				position: absolute;
				top: 0px;
				right: -3px;
				bottom: -3px;
				left: 0px;
				margin: auto;
			}

			.score-rays,
			.score-heading {
				display: none;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/abstract/ScoreMedallion.vue